<div class="detail-content__section mb-5">
  <h5 class="detail-steps__title">Soluzioni disponibili</h5>
  <div class="c-detail-steps-solution">
    <div class="c-detail-steps-solution__wrapper">
      <h6>Scegli la tipologia di viaggio:</h6>
      <div class="c-detail-steps-solution__type">
        <span *ngFor="let parentType of availablesParentTypes"
              (click)="selectParentType(parentType)"
              [ngClass]="{'active': parentType === selectedParentType}">
          {{parentType}}
        </span>
      </div>
    </div>
  </div>
  <div class="c-detail-steps-solution">
    <div class="c-detail-steps-solution__wrapper">
      <h6>Mese:</h6>
      <div class="c-detail-steps-solution__months">
        <span *ngFor="let month of availablesMonths"
              (click)="selectMonth(month)"
              [ngClass]="{'active': month === selectedMonth}">
          {{month}}
        </span>
      </div>
    </div>
    <div class="c-detail-steps-solution__wrapper flex-grow-0">
      <h6>Durata notti:</h6>
      <div class="c-detail-steps-solution__nights">
        <span *ngFor="let nights of availablesNights"
              (click)="selectNight(nights)"
              [ngClass]="{'active': nights === selectedNights}">
          {{nights}}
        </span>
      </div>
    </div>
  </div>

  <div *ngIf="solutionsGroupedForPriceGrid && departurePlacesGroupedForPriceGrid"
       class="c-detail-price-grid">
    <div class="c-detail-price-grid__airports">
      <div class="c-detail-price-grid__dates">
        <span>&nbsp;</span>
      </div>
      <!-- ciclo i departurePlaces -->
      <!-- applico l'active-row sulla riga dove è presente la solution selezionata (o la searchSolution) in precedenza dal listato di ricerca -->
      <div
        *ngFor="let departurePlaceId of departurePlacesGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights]"
        class="c-detail-price-grid__airports-item"
        [ngClass]="{
            'active-row': selectedDeparturePlaceIdByTypeMonthAndNights &&
              selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType] &&
              selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType][selectedMonth] &&
              departurePlaceId === selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType][selectedMonth][selectedNights]
           }">
        <span *ngIf="departurePlaceId && departurePlaceId > 1000000 && departurePlaceId < 3000000">
          <!-- se è presente departurePlaceId, verifico che sia compreso tra l'id 1000000 e 3000000 -->
          <span class="airports">
            {{(departurePlaceId | getDataFromMapping:'airportId' | async)?.Name}}
          </span>
          <!-- verifico che sia compreso tra l'id 1000000 e 2000000 in modo che si possa stampare anche il "Code" (in questo caso si tratta di un aeroporto) -->
          <span *ngIf="departurePlaceId > 1000000 && departurePlaceId < 2000000">
            ({{(departurePlaceId | getDataFromMapping:'airportId' | async)?.Code}})
          </span>
        </span>
        <span *ngIf="!departurePlaceId || (departurePlaceId && departurePlaceId >= 3000000)">
          <!-- se departurePlaceId non è presente oppure è maggiore o uguale all'id 3000000, allora si tratta di un solo soggiorno -->
          <span>Solo Soggiorno</span>
        </span>
      </div>
    </div>
    <swiper [config]="config" [(index)]="index" class="c-detail-price-grid__choices">
      <!-- ciclo le solution raggruppate per data -->
      <div
        *ngFor="let solutionsGroupedByDate of solutionsGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights] | keyvalue"
        class="slide c-detail-price-grid__col">
        <!-- riga delle date -->
        <div class="c-detail-price-grid__dates">
          <span class="day-of-week">{{$any(solutionsGroupedByDate.key) | dayjs: 'ddd'}}</span>
          <span class="day">{{$any(solutionsGroupedByDate.key) | dayjs: 'DD'}}<span
            class="text-uppercase">{{$any(solutionsGroupedByDate.key) | dayjs: 'MMM'}}</span></span>
        </div>
        <!-- fine riga delle date -->
        <!-- racchiudo tutto in un div per poter ciclare ogni riga che rappresenta il departurePlace -->
        <!-- applico anche qui l'active-row sulla riga dove è presente la solution selezionata (o la searchSolution) in precedenza dal listato di ricerca -->
        <div
          *ngFor="let departurePlaceId of departurePlacesGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights]"
          [ngClass]="{
              'active-row': selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType] &&
                selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType][selectedMonth] &&
                departurePlaceId === selectedDeparturePlaceIdByTypeMonthAndNights[selectedParentType][selectedMonth][selectedNights]
             }">
          <!-- se non esistono solutions per il departurePlaceId ciclato, allora visualizzo una casella vuota per lasciare ordinata la griglia -->
          <div
            *ngIf="!solutionsGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights][solutionsGroupedByDate.key][departurePlaceId]"
            class="c-detail-price-grid__price-item not-available-empty"></div>
          <!-- ... altrimenti, proseguo e ciclo le solutions per popolare ogni casella con i dati della solution ciclata -->
          <ng-container
            *ngIf="solutionsGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights][solutionsGroupedByDate.key][departurePlaceId]">
            <div
              *ngFor="let solution of solutionsGroupedForPriceGrid[selectedParentType][selectedMonth][selectedNights][solutionsGroupedByDate.key][departurePlaceId]"
              [ngClass]="{'active': solution.solutionIdOrSource === selectedSolution?.solutionIdOrSource}"
              (click)="selectSolution(solution)"
              class="c-detail-price-grid__price-item">
              <div class="c-detail-price-grid__price">
                <!-- mostro il loader solo nella casella della solution selezionata -->
                <span *ngIf="isLoading && solution.solutionIdOrSource === selectedSolution?.solutionIdOrSource"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true">
                </span>
                <ng-container
                  *ngIf="solution.isShownPriceLive || solution.solutionIdOrSource === selectedSolution?.solutionIdOrSource; else showPriceMessage">
                <span
                  *ngIf="(!isLoading && solution.solutionIdOrSource === selectedSolution?.solutionIdOrSource) || (solution.solutionIdOrSource !== selectedSolution?.solutionIdOrSource)">
                  <small>da&nbsp;</small>
                  <span *ngIf="solution.totalPrice">{{solution.totalPrice | number:'1.0-0'}} €<small
                    class="price-title-guests">(totale)</small></span>
                  <span *ngIf="!solution.totalPrice && solution.price">{{solution.price | number:'1.0-0'}} €<small
                    class="price-title-guests">(per persona)</small></span>
                </span>
                </ng-container>

              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </swiper>
  </div>
</div>

<ng-template #showPriceMessage>
  <span> Vedi prezzo
    <small class="price-title-guests click">clicca qui</small>
  </span>
</ng-template>
